import { Component } from '@angular/core';
import { LocaleAwareBaseComponent } from 'common';

@Component({
  selector: 'app-app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})

export class AppFooterComponent extends LocaleAwareBaseComponent {
  today: Date = new Date();
}
